import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-modal';
import featureAction from "../../../redux/feature/actions";
import './ProjectModal.css';

import { useTranslation } from "react-i18next";

Modal.setAppElement('#root');

function IsOpenProjectModal() {
    const { t, i18n } = useTranslation();
    const [projectName, setProjectName] = useState('');

    const assetsPath = useSelector(state => state.Feature.assetsPath);
    const mdClose = process.env.PUBLIC_URL + assetsPath + 'images/md-close.svg';

    const dispatch = useDispatch();
    const isOpen = useSelector((state) => state.Feature.isOpenProjectModal);
    const _coloursOnCanvas = useSelector((state) => state.Feature.coloursOnCanvas);
    const _priceData = useSelector((state) => state.Feature.priceData);

    const closeModal = () => {
        dispatch(featureAction.isOpenProjectModal());
    };

    // const deleteProject = () => {
    //     // dispatch(featureAction.removeColourOnCanvas(updatedColour.from.id_product_attribute));
    //     // dispatch(featureAction.isOpenCanvasItemConfigModal());
    // }

    const createProject = () => {
        if(!projectName) return;

        const payload = {
            // objectID: -1,
            objectName: projectName,
            object: {
                objectName: projectName,
                userColours: [],
                coloursOnCanvas: _coloursOnCanvas,
                priceData: _priceData
            }
        }
        //dispatch(featureAction.createProject(payload));
        dispatch({
            type: featureAction.CREAT_PROJECT_REQUEST,
            payload
        });
        closeModal();
    }

    const _objectId = useSelector(state => state.Feature.selectedObjectId);
    const deleteProject = () => {
        closeModal();
        // return;
        // const payload = {
        //     objectID: _objectId,
        // }
        // dispatch({
        //     type: featureAction.DELET_PROJECT_REQUEST,
        //     payload
        // });
        // closeModal();
    }

    return (
        <div className='confirm-modal'>
          <Modal
            isOpen={isOpen}
            // onRequestClose={() => setModalIsOpen(false)}
            shouldCloseOnOverlayClick={false}
            contentLabel="Example Modal"
            style={{
              overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.75)'
              },
              content: {
                width: '527px',
                height: '311px',
                margin: 'auto',
                borderRadius: '0', // No border radius
                padding: '0'
              }
            }}
          >
            <div className='cicm-header'>
              <div className='cicm-header-title'>{t('ADD PROJECT')}</div>
              <div className='cicm-header-close' onClick={closeModal}>
                <img src={mdClose} alt='close'/>
              </div>
            </div>
            <div className='project-modal-body'>
                <p className='project-modal-body-title'>{t('Project name')}</p>
                <div className='value-input-box-container'>
                    <input
                        className="value-input-box"
                        placeholder={t('Enter project name')}
                        value={projectName}
                        onChange={(e) => setProjectName(e.target.value)}
                    />
                </div>
            </div>
            <div className='cicm-footer'>
              <div className='acp-delete-button' onClick={deleteProject}>
                {/* <svg className="acp-delete-icon" width="12" height="14" viewBox="0 0 12 14" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.15717 13.0831C2.78745 13.0831 2.47169 12.9523 2.20988 12.6906C1.94822 12.4288 1.81738 12.113 1.81738 11.7433V1.99978H0.817383V0.916445H4.40072V0.0126953H8.40072V0.916445H11.984V1.99978H10.984V11.7344C10.984 12.1196 10.8545 12.4408 10.5955 12.6977C10.3365 12.9546 10.0194 13.0831 9.64426 13.0831H3.15717ZM9.90072 1.99978H2.90072V11.7433C2.90072 11.8182 2.92474 11.8796 2.9728 11.9277C3.02085 11.9758 3.08231 11.9998 3.15717 11.9998H9.64426C9.70843 11.9998 9.76718 11.973 9.82051 11.9196C9.87398 11.8662 9.90072 11.8075 9.90072 11.7433V1.99978ZM4.73738 10.4998H5.82051V3.49978H4.73738V10.4998ZM6.98092 10.4998H8.06405V3.49978H6.98092V10.4998Z"
                    fill="#BF0000"/>
                </svg> */}
                {t('Cancel')}
              </div>
              <div>
                <div className='cicm-footer-no' onClick={createProject}>{t('Create')}</div>
              </div>
            </div>
          </Modal>
        </div>
      );
}

export default IsOpenProjectModal;